import { render } from "./SessionDetails.vue?vue&type=template&id=f1c98976"
import script from "./SessionDetails.vue?vue&type=script&lang=js"
export * from "./SessionDetails.vue?vue&type=script&lang=js"

import "./SessionDetails.vue?vue&type=style&index=0&id=f1c98976&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__